import { render, staticRenderFns } from "./SihaoList.vue?vue&type=template&id=0bfa2851&"
import script from "./SihaoList.vue?vue&type=script&lang=js&"
export * from "./SihaoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports